import React from 'react';
import FormSetting from '../../layout/FormSetting';
import Input from '../../forms/Input';
import TextArea from '../../forms/TextArea';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';
import PhoneNumberInput from '../../forms/formComponents/PhoneNumberInput';
import Button from '../../forms/Button';
import { userRoles } from '../../RoleProtected';
import { releaseAllDeviceIDs } from './Mobile';

const Settings = ({ ...props }) => {

    return (
        <FormSetting
            label='Settings'
            getInputs={QuestRoute.settings.support}
            onSubmit={e => HamQuest.put(QuestRoute.settings.support, { ...e })}
            controls={[<Button roles={userRoles.admin} onClick={releaseAllDeviceIDs}>Release All Device IDs</Button>]}
            editable
        >
            <PhoneNumberInput
                name='supportPhone'
            />
            <Input
                label='Email'
                name='supportEmail'
            />
            <TextArea
                label='FAQ'
                name='supportFaqs'
            />
            <TextArea
                label='Terms and Conditions'
                name='terms'
            />
            <Input
                label='Email Validation Message'
                name='emailValidationMessage'
            />
        </FormSetting>
    );
}

export default Settings;